export const QueuesStatuses = {
  QUEUE_WAITING: 0,
  QUEUE_POPPED: 1,
  QUEUE_CANCELLED: 2,
}
export const QueuesActions = [
  {
    icon: 'CheckSquareIcon', label: 'queues.complete', action: 'Complete', show: [0],
  },
  {
    icon: 'XCircleIcon', label: 'queues.cancel', action: 'Cancel', show: [0],
  },
  {
    icon: 'ListIcon', label: 'queues.back-waiting', action: 'BackWaiting', show: [1, 2],
  },
]
